module.exports = __webpack_public_path__ + "static/datamanagementbanner-4268b2413a3534c6bcbdb44a963454e4.jpg";